export const questionario = {
    PESQUISA_PERGRESP: 'PESQUISA_PERGRESP',
    CADATUALIZAPERG: 'CADATUALIZAPERG',
    PESQUISA_RESP: 'PESQUISA_RESP',
    CADATUALIZARESP: 'CADATUALIZARESP'
}